controllers.controller('TncController', [
    '$scope', '$state', '$ionicLoading', '$ionicModal', 'LocaleService', 'UserService', 'API',
    'Utils', 'Storage', 'constants', 'ErrorService',
    function ($scope, $state, $ionicLoading, $ionicModal, LocaleService, UserService, API,
              Utils, Storage, Const, ErrorService) {

        $scope.tnc = false;
        $scope.constants = Const;
        $scope.lang = "en";

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false
        };
        $scope.modal = angular.copy(modalDefaults);

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
            $scope.lang = LocaleService.lang;
        });

        $scope.navigate = function (state, params) {
            return $state.go(state, params);
        };

        $scope.onNext = function (form) {
            Utils.formRevalidate(form, true);
            if (!form.$valid) return;

            $ionicLoading.show();

            return API.acceptTnc()
                .then(checkResponse)
                .then(function () {
                    var user = UserService.get();
                    user.tnc = true;
                    $ionicLoading.hide();
                    return $state.go('root.app.assets', {cache: false});
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && error.code && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
                    $scope.modal.actionText = LocaleService.translation.try_again;
                    $scope.modal.state = true;
                });
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'TncController',
                    type: Const.error.type.VALIDATION,
                    code: data.code.toString() || 'updateTncFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

    }]);
